import React from 'react'
import { navigate } from 'gatsby'

import LogoSvg from 'images/logo.svg'

import { LogoContainer, LogoVeterinária, LogoDerosso } from './Logo.styles'

const Logo = () => {
  return (
    <LogoContainer onClick={() => navigate('/')}>
      <LogoVeterinária src={LogoSvg} />
    </LogoContainer>
  )
}

export default Logo
